module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/icon-local@3x-d4cbc092f9df8cfaee142b00a0130bed.png";